import React from "react";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import { REWARD_POLICIES } from "../../../constants/promotionConstants";

const StepPolicy = ({ promotion, onChange }) => {
  const policy = promotion.policy;

  // "Specific Product / Fixed Product" only makes sense when targeting a specific product.
  // For CATEGORY / BRAND / COMBO targets the customer must select or the engine auto-picks.
  const rewardTargetType = promotion.reward?.targetType || "product";
  const options = REWARD_POLICIES.filter((opt) => {
    if (opt.value === "fixedProduct" || opt.value === "SPECIFIC_PRODUCT") {
      return rewardTargetType === "product";
    }
    return true;
  });

  return (
    <div>
      <h5 className="mb-4">Reward Policy</h5>
      <Row className="mb-4">
        <Col md={6}>
          <FormGroup>
            <Label for="selection">Reward Policy</Label>
            <Input
              type="select"
              id="selection"
              value={policy.selection}
              onChange={(e) => onChange("selection", e.target.value)}
            >
              {options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Input>
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label for="maxRewardQuantity">Maximum Reward Quantity</Label>
            <Input
              id="maxRewardQuantity"
              type="number"
              min="0"
              value={policy.maxRewardQuantity}
              onChange={(e) => onChange("maxRewardQuantity", e.target.value)}
            />
          </FormGroup>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={4}>
          <FormGroup>
            <Label for="rewardRepeatMode">Reward Repeat</Label>
            <Input
              type="select"
              id="rewardRepeatMode"
              value={policy.rewardRepeatMode}
              onChange={(e) => onChange("rewardRepeatMode", e.target.value)}
            >
              <option value="UNLIMITED">Unlimited</option>
              <option value="LIMITED">Limited</option>
            </Input>
          </FormGroup>
        </Col>
        {policy.rewardRepeatMode === "LIMITED" && (
          <Col md={4}>
            <FormGroup>
              <Label for="rewardLimit">Reward Limit</Label>
              <Input
                id="rewardLimit"
                type="number"
                min="1"
                value={policy.rewardLimit}
                onChange={(e) => onChange("rewardLimit", e.target.value)}
              />
            </FormGroup>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default StepPolicy;
